import { useLingui } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { Item } from './Item';

export const ArticlePurchaseLocation = () => {
  const { t } = useLingui();
  const { article } = useArticleContext();

  return (
    <Item
      label={t({ id: 'article.information.purchase-location', message: 'Purchase location' })}
      value={article.purchaseLocation}
    />
  );
};
